module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/congress/shared/layout/menu-page/menu-page.component.css
// module id = ./src/congress/shared/layout/menu-page/menu-page.component.css
// module chunks = main